import { authConstants, learningCoursesConstants, learningCentreConstants } from "_constants";

const initialState = {
	isFetching: false,
	isFetchError: false,
	deleteInProgress: false,
	course: {},
	createLearningCourseSuccess: false,
	updateLearningCourseSuccess: false,
	deleteLearningCourseSuccess: false,
	navigationObject: {
		root: {
			searchKey: "",
			district: "",
			category: "",
			sortingKey: "name",
			sortingDirection: "ASC",
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
			learningCoursesList: [],
		},
		organization: {
			searchKey: "",
			district: "",
			category: "",
			sortingKey: "name",
			sortingDirection: "ASC",
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
			learningCoursesList: [],
			learningCenterKey: "",
		},
		center: {
			searchKey: "",
			district: "",
			category: "",
			sortingKey: "name",
			sortingDirection: "ASC",
			numOfPage: 1,
			currentPage: 1,
			totalItems: 0,
			learningCoursesList: [],
			learningCenterKey: "",
		},
	},
};

const learningCoursesReducer = (state = initialState, action) => {
	switch (action.type) {
		case authConstants.type.UNAUTHORIZED_ERROR: {
			let navigationObject = initialState.navigationObject;
			if (typeof state.navigationObject?.organization != "undefined") {
				navigationObject = {
					...state.navigationObject,
					organization: { ...state.navigationObject?.organization, currentPage: 1 },
				};
			}
			if (typeof state.navigationObject?.root != "undefined") {
				navigationObject = {
					...state.navigationObject,
					root: { ...state.navigationObject?.root, currentPage: 1 },
				};
			}
			if (typeof state.navigationObject?.center != "undefined") {
				navigationObject = {
					...state.navigationObject,
					center: { ...state.navigationObject?.center, currentPage: 1 },
				};
			}
			return {
				...state,
				navigationObject: navigationObject,
			};
		}
		case learningCoursesConstants.type.FETCH_LEARNING_COURSES_LIST_REQUEST: {
			return {
				...state,
				isFetching: true,
				isFetchError: false,
			};
		}
		case learningCoursesConstants.type.FETCH_LEARNING_COURSES_LIST_FAILURE: {
			return {
				...state,
				isFetching: false,
				isFetchError: true,
			};
		}
		case learningCentreConstants.type.FETCH_CENTRE_SUCCESS: {
			if (action.navigationKey) {
				const navigationObject = {
					searchKey: action.searchKey || "",
					district: action.district || "",
					category: action.category || "",
					sortingKey: action.sortingKey || "",
					sortingDirection: action.sortingDirection || "",
					totalItems: action.totalNum,
					numOfPage: action.totalPage,
					currentPage: action.currentPage,
					learningCoursesList: action.learningCoursesList,
					learningCenterKey: action?.centre?._key,
				};
				return {
					...state,
					isFetching: false,
					isFetchError: false,
					navigationObject: {
						...state.navigationObject,
						[`${action.navigationKey}`]: {
							...navigationObject,
						},
					},
				};
			} else {
				return state;
			}
		}
		case learningCoursesConstants.type.FETCH_LEARNING_COURSES_LIST_SUCCESS: {
			const navigationObject = {
				searchKey: action.searchKey,
				district: action.district,
				category: action.category,
				sortingKey: action.sortingKey,
				sortingDirection: action.sortingDirection,
				totalItems: action.totalNum,
				numOfPage: action.totalPage,
				currentPage: action.currentPage,
				learningCoursesList: action.learningCoursesList,
				learningCenterKey: state.navigationObject[action.navigationKey].learningCenterKey,
			};
			return {
				...state,
				isFetching: false,
				isFetchError: false,
				navigationObject: {
					...state.navigationObject,
					[`${action.navigationKey}`]: {
						...navigationObject,
					},
				},
			};
		}
		case learningCoursesConstants.type.FETCH_COURSES_REQUEST: {
			return {
				...state,
				isFetching: true,
				isFetchError: false,
				course: {},
			};
		}
		case learningCoursesConstants.type.FETCH_COURSES_FAILURE: {
			return {
				...state,
				isFetching: false,
				isFetchError: true,
			};
		}
		case learningCoursesConstants.type.FETCH_COURSES_SUCCESS: {
			return {
				...state,
				isFetching: false,
				isFetchError: false,
				course: action.course,
			};
		}
		case learningCoursesConstants.type.CREATE_LEARNING_COURSES_REQUEST: {
			return {
				...state,
				isFetching: true,
				createLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.CREATE_LEARNING_COURSES_FAILURE: {
			return {
				...state,
				isFetching: false,
				createLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.CREATE_LEARNING_COURSES_SUCCESS: {
			return {
				...state,
				isFetching: false,
				createLearningCourseSuccess: true,
			};
		}
		case learningCoursesConstants.type.UPDATE_LEARNING_COURSES_REQUEST: {
			return {
				...state,
				isFetching: true,
				updateLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.UPDATE_LEARNING_COURSES_FAILURE: {
			return {
				...state,
				isFetching: false,
				updateLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.UPDATE_LEARNING_COURSES_SUCCESS: {
			return {
				...state,
				isFetching: false,
				updateLearningCourseSuccess: true,
			};
		}
		case learningCoursesConstants.type.DELETE_LEARNING_COURSES_REQUEST: {
			return {
				...state,
				deleteInProgress: true,
				deleteLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.DELETE_LEARNING_COURSES_FAILURE: {
			return {
				...state,
				deleteInProgress: false,
				deleteLearningCourseSuccess: false,
			};
		}
		case learningCoursesConstants.type.DELETE_LEARNING_COURSES_SUCCESS: {
			return {
				...state,
				deleteInProgress: false,
				deleteLearningCourseSuccess: true,
			};
		}
		case learningCoursesConstants.type.RESET_LEARNING_COURSES_SUCCESS: {
			return {
				...state,
				createLearningCourseSuccess: false,
				updateLearningCourseSuccess: false,
				deleteLearningCourseSuccess: false,
				isFetchError: false,
			};
		}
		default: {
			return state;
		}
	}
};

export default learningCoursesReducer;
